import * as React from 'react';
import { SVGProps } from 'react';

const SvgSortOrder = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 10V7l5-5 5 5v3l-5-5-5 5zm10 4v3l-5 5-5-5v-3l5 5 5-5z" />
  </svg>
);

export default SvgSortOrder;
